import type { PromotionType } from '@weft/types';
import { PROMOTION_TYPES } from '@weft/types';
import type { PromotionSetting } from '../create-plan-page-types/promotion-setting';

export const PROMOTION_SETTINGS: Record<PromotionType, PromotionSetting> = {
  [PROMOTION_TYPES.FreeTrial]: {
    units: 'daysFree',
    label: 'Free trial',
    placeholder: 'of Days',
    prefix: '#',
    disabled: true,
  }, 
  [PROMOTION_TYPES.Credit]: {
    units: 'creditAmount',
    label: 'Credit',
    prefix: '$',
  },
  [PROMOTION_TYPES.Percentage]: {
    units: 'percentage',
    label: 'Percentage',
    prefix: '%',
  },
};